export const clockConstants = {
    FETCH_REQUEST: 'CLOCK_FETCH_REQUEST',
    FETCH_SUCCESS: 'CLOCK_FETCH_SUCCESS',
    FETCH_FAILURE: 'CLOCK_FETCH_FAILURE', 
    REPROCESS_REQUEST: 'CLOCK_REPROCESS_REQUEST',
    REPROCESS_SUCCESS: 'CLOCK_REPROCESS_SUCCESS',
    REPROCESS_FAILURE: 'CLOCK_REPROCESS_FAILURE', 
};
